module.exports = __webpack_public_path__ + "img/extensao-png.cef4b028.png";